// extracted by mini-css-extract-plugin
module.exports = {"load-more":"PostList_load-more__6z117","spaces-enabled-empty-state":"PostList_spaces-enabled-empty-state__Zb5qn","is-home":"PostList_is-home__rNN6s"};